export default __webpack_public_path__ + "static/media/login-background.e33ec121.png";